import fullscreenTemplate from './custom-fullscreen/fullscreen-template.twig';
import zoomTemplate from './custom-zoom/zoom-template.twig';

class Controls {
    constructor() {
        this.map = '';
        this.settings = '';
        this.ymaps = '';
    }

    init(map, settings, ymaps) {
        this.map = map;
        this.settings = settings;
        this.ymaps = ymaps;

        this._initZoom(this.settings, this.map, this.ymaps);
        this._initScrollZoom(this.settings, this.map, this.ymaps);
        this._addFullScreenControl(this.settings, this.map, this.ymaps);

        if (this.settings.disableMobileDrag) {
            this._disableMobileDrag();
        }
    }

    /**
     * Добавляет зум на карту.
     * @param {Object} settings Объект настроек
     * @param {Object} map Объект карты
     * @param {Object} ymaps Объект яндекс карт
     * @private
     */
    _initZoom(settings, map, ymaps) {
        if (!settings.zoomControl) {
            return;
        }

        if (settings.customZoomControl) {
            this._initCustomZoomControl(settings, map, ymaps);
        } else {
            map.controls.add(`zoomControl`);
        }
    }

    /**
     * Разрешает или запрещает сколл страницы при фокусе на карте.
     * @param {Object} settings Объект настроек
     * @param {Object} map Объект карты
     */
    _initScrollZoom(settings, map) {
        const scrollZoom = settings.zoomScroll;

        if (scrollZoom) {
            map.behaviors.enable('scrollZoom');
        } else {
            map.behaviors.disable('scrollZoom');
        }
    }

    /**
     * Добавляет кнопку открытия карты на полный экран
     * @param {Object} settings Объект настроек
     * @param {Object} map Объект карты
     * @param {Object} ymaps Объект яндекс карт
     */
    _addFullScreenControl(settings, map, ymaps) {
        if (!settings.fullScreenControl) {
            return;
        }

        if (settings.customFullScreenControl) {
            this._initCustomFullscreenControl(ymaps, map);
        } else {
            map.controls.add('fullscreenControl');
        }
    }

    /**
     * Отключаем перетаскивание карты при прокрутке одним пальцем на мобилке
     */
    /* eslint-disable */
    _disableMobileDrag() {
        const isMobile = {
            Android: () => {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: () => {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: () => {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: () => {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: () => {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: () => {
                return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
            }
        };

        if (isMobile.any()) {
            this.map.behaviors.disable('drag');
        }
    }
    /* eslint-enable */

    /**
     * Инициализация кастомных контролов
     * @param {Object} settings Объект настроек
     * @param {Object} maps Объект карты
     * @param {Object} ymaps Объект яндекс карт
     */
    _initCustomZoomControl(settings, maps, ymaps) {
        const height = maps.container._size[1];
        const mapId = maps.container._parentElement.id;

        const ZoomLayout = ymaps.templateLayoutFactory.createClass(zoomTemplate({mapId}), {

            // Переопределяем методы макета, чтобы выполнять дополнительные действия
            // при построении и очистке макета.
            build() {
                // Вызываем родительский метод build.
                ZoomLayout.superclass.build.call(this);

                // Начинаем слушать клики на кнопках макета.
                document.querySelector(`#${mapId}-zoom-in`).addEventListener('click', () => {
                    this.zoomIn();
                });
                document.querySelector(`#${mapId}-zoom-out`).addEventListener('click', () => {
                    this.zoomOut();
                });
            },

            clear() {
                // Вызываем родительский метод clear.
                ZoomLayout.superclass.clear.call(this);
            },

            zoomIn() {
                const map = this.getData().control.getMap();

                map.setZoom(map.getZoom() + 1, {
                    checkZoomRange: true
                });
            },

            zoomOut() {
                const map = this.getData().control.getMap();

                map.setZoom(map.getZoom() - 1, {
                    checkZoomRange: true
                });
            }
        });

        const zoomControl = new ymaps.control.ZoomControl({
            options: {
                layout  : ZoomLayout,
                position: {
                    top  : height / 2,
                    right: 16
                }
            }
        });


        this.map.controls.add(zoomControl);
    }

    _initCustomFullscreenControl(ymaps, map) {
        const FullscreenLayout = ymaps.templateLayoutFactory.createClass(fullscreenTemplate());

        const fullscreenControl = new ymaps.control.FullscreenControl({
            options: {
                layout  : FullscreenLayout,
                position: {
                    top  : null,
                    right: 0
                }
            }
        });

        map.controls.add(fullscreenControl);
    }
}

export default Controls;
